import React from "react";
import TgridAmindLogin from "./TgridAmindLogin";

const TgridAmindLoginBackSplash = () => {
  return (
    <div className="porch">
      <TgridAmindLogin />
    </div>
  );
};

export default TgridAmindLoginBackSplash;
